'use strict';

var App = require('app');
var Controller = require('components/help/help_controller');

var HelpComponent = {};

HelpComponent.initializeRouting = function () {
    new HelpComponent.Router({
        controller: API,
    });
};

HelpComponent.Router = App.BaseRouter.extend({
    appRoutes: {
        imprint: 'showImprint',
        terms: 'showTerms',
        data_protection: 'showDataProtection',
        support: 'showSupport',
        tour: 'getHelpTour',
    },
});

var API = {
    showImprint: function () {
        Controller.showImprint();
    },

    showTerms: function () {
        Controller.showTerms();
    },

    showDataProtection: function () {
        Controller.showDataProtection();
    },

    showSupport: function () {
        Controller.showSupport();
    },

    getHelpTour: function (url, onlyLook) {
        return Controller.getHelpTour(url, onlyLook);
    },
};

App.on('help:imprint', function () {
    API.showImprint();
});

App.on('help:terms', function () {
    API.showTerms();
});

App.on('help:dataProtection', function () {
    API.showDataProtection();
});

App.on('help:support', function () {
    API.showSupport();
});

App.reqres.setHandler('help:tour', function (url, onlyLook) {
    return API.getHelpTour(url, onlyLook);
});

module.exports = HelpComponent;
